import * as React from "react";
import { FiCheckCircle } from "react-icons/fi";
import "twin.macro";

const SERVICES = [
  "Heckenpflanzung- und Schnitt",
  "Gehölzschnitt",
  "Rasenmähen",
  "Vertikutieren",
  "Bepflanzungen",
  "Bäume schneiden",
  "Pflasterarbeiten",
  "Gartenpflege",
];

export default function Services() {
  return (
    <section id="service" tw="bg-gray-100">
      <div tw="container mx-auto py-24 px-6">
        <h2 tw="text-4xl lg:text-5xl font-medium text-center">
          Unsere <span tw="text-primary">Leistungen</span>
        </h2>
        <div tw="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mt-12">
          {SERVICES.map((service) => (
            <div
              key={service}
              tw="bg-white py-6 px-5 flex items-center font-medium border-l-4 border-primary shadow-lg rounded-r-lg"
            >
              <span tw="flex-shrink-0 mr-4 text-primary p-3 rounded-full bg-primary bg-opacity-20">
                <FiCheckCircle size="22" />
              </span>
              <p tw="leading-snug">{service}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
